export const onProgramChange = async (programId, filters, filtersUpdater) => {
  const finalFilters = { ...filters, programId, batchId: undefined };
  filtersUpdater(prevFilters => ({
    ...prevFilters,
    ...finalFilters
  }));
  return finalFilters;
};
